"use client";

import { GoogleTagManager } from "@next/third-parties/google";
import { Datadog } from "@yardzen/components/datadog";
import { AppProviders } from "@yfp/context/providers";
import { ReactNode } from "react";

const googleTagManagerId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

export function ClientLayout({ children }: { children: ReactNode }) {
  return (
    <>
      {googleTagManagerId && (
        <GoogleTagManager
          gtmId={googleTagManagerId}
          gtmScriptUrl="https://yardwork.yardzen.com/gtm.js"
        />
      )}
      <Datadog service="yardzen-for-pros" />
      <AppProviders>{children}</AppProviders>
    </>
  );
}
